import { createApp } from 'vue'


// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import '../styles/style.css'

import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'

const vuetify = createVuetify({
    components,
    directives,
  })


  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('access_token')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

createApp(App).use(store).use(router).use(vuetify).mount('#app')
